import ToysIcon from '@material-ui/icons/Toys';
import PropTypes from 'prop-types';
import React from 'react';

const PointIcon = ({ fillColor = 'black', fontSize = undefined, strokeColor = 'white' }) => (
    <ToysIcon stroke={strokeColor} style={{ color: fillColor, fontSize }} />
);

PointIcon.propTypes = {
    fillColor: PropTypes.string,
    fontSize: PropTypes.string,
    strokeColor: PropTypes.string,
};

export default PointIcon;